import Button from "../button/Button";
import React from "react";
import {useLanguage} from "../../hooks/LanguageContext";
import WarningAlert from "../common/WarningAlert";

export const vehicleSizeOptions = [
    "سيارة صغيرة",
    "سيارة كبيرة-جيب",
    "سيارة وسط",
    "شحن مميز",
    "شحن سطحه خاصة",
    "شحن سطحه داخلي",
    "شحن سطحه كبيرة",
    "شحن حمولة ناقلة",
    "سيارة دينا",
    "حمولة كاملة",
    "دينا 4 طن",
    "دينا 6 طن",
    "يورفان",
    "كوستر"
];

const BookingInfoStep1 = ({ data, errors,branches , handleNext, handleInputChange }) => {
    const { direction, language } = useLanguage();
    const fromLocationText = direction === "rtl" ? "من الموقع" : "From location";
    const toLocationText = direction === "rtl" ? "الى موقع" : "To location";



    return (
        <div className="flex flex-col justify-center items-center  space-y-6 mt-12 container">
            <div className="flex justify-center gap-8 md:gap-16 w-full md:w-auto container">
                <div className="space-y-2 flex-1">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">{fromLocationText}</span>
                    </div>
                    <select
                        name="fromLocation"
                        value={data.fromLocation}
                        onChange={handleInputChange}
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] border-2 border-primary-700  p-2"
                    >
                        <option value="" disabled={true} >اختيار</option>
                        {branches.map((branch, index) => (
                            <option key={branch.id} value={branch.id}>
                                {branch.name_ar}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="space-y-2 flex-1">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">{toLocationText}</span>
                    </div>
                    <select
                        name="toLocation"
                        value={data.toLocation}
                        onChange={handleInputChange}
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] border-2 border-primary-700  p-2"
                    >
                        <option value="" disabled={true} >اختيار</option>
                        {branches.map((branch, index) => (
                            <option key={branch.id} value={branch.id}>
                                {branch.name_ar}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="flex justify-center gap-8 md:gap-16 w-full md:w-auto container">
                <div className="space-y-2 flex-1">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">حجم السيارة</span>
                    </div>
                    <select
                        name="shipmentType"
                        value={data.vehicleSize}
                        onChange={handleInputChange}
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] border-2 border-primary-700  p-2"
                    >
                        <option value="" disabled={true} >اختيار</option>
                        {vehicleSizeOptions.map((option, index) => (
                            <option key={index} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="space-y-2 flex-1">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">تاريخ التحميل</span>
                    </div>
                    <input
                        type="date"
                        name="loadingDate"
                        value={data.loadingDate}
                        onChange={handleInputChange}
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] border-2 border-primary-700  p-2"
                    />
                </div>

            </div>

            <WarningAlert alert="السيارات الفارهة والسيارات المعدلة لا يمكن حجزها عن طريق الموقع الإلكتروني، فقط من خلال الفرع." />


            <Button onClick={handleNext} className="mr-auto !mt-12">
                {language === "ar" ? "التالي" : "Next"}
            </Button>
        </div>
    );
};

export default BookingInfoStep1;
